import { FoodCardData } from "@payment-ui/interfaces";

export const CARD_PAYMENT_ICON_WIDTH = 36;

export const DEFAULT_CARD_DATA_STATE: FoodCardData = {
    balance: "--",
    cvvRequired: true,
    isBalanceSufficent: true,
    additionalBalanceRequired: 0,
};

export enum FLOW_TYPE {
    NOT_TOKENIZED_CARD,
    SECURED_CARD,
}
